export const BellIcon = ({
	size = 16,
	className,
}: {
	size?: number;
	className?: string;
}) => {
	return (
		<svg
			width={size * (14 / 16)}
			height={size * (18 / 16)}
			viewBox="0 0 14 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			style={{ color: "currentcolor" }}
			role="img"
			aria-label="Notifications bell icon"
		>
			<title>Notifications</title>
			<path
				d="M5.33325 15.6665H8.66659C8.66659 16.587 7.92039 17.3332 6.99992 17.3332C6.07944 17.3332 5.33325 16.587 5.33325 15.6665Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.99992 0.666504C6.53968 0.666504 6.16659 1.0396 6.16659 1.49984V2.33317C6.16659 2.35629 6.16753 2.3792 6.16937 2.40184C3.80326 2.79744 1.99995 4.85471 1.99995 7.33317V8.9643C1.99995 9.32322 1.87003 9.67001 1.63419 9.94058L1.09715 10.5567C-0.641866 12.5517 0.775078 15.6665 3.42166 15.6665H10.5782C13.2248 15.6665 14.6418 12.5517 12.9028 10.5567L12.3657 9.94058C12.1299 9.67001 12 9.32322 12 8.9643V7.33317C12 4.85469 10.1966 2.7974 7.83046 2.40183C7.83231 2.37919 7.83325 2.35629 7.83325 2.33317V1.49984C7.83325 1.0396 7.46016 0.666504 6.99992 0.666504ZM3.66662 7.33317C3.66662 5.49222 5.15901 3.99984 6.99996 3.99984C8.8409 3.99984 10.3333 5.49222 10.3333 7.33317V8.9643C10.3333 9.72584 10.609 10.4616 11.1094 11.0357L11.6464 11.6518C12.4455 12.5686 11.7944 13.9998 10.5782 13.9998H3.42166C2.20552 13.9998 1.55442 12.5686 2.35352 11.6518L2.89055 11.0357C3.39095 10.4616 3.66662 9.72584 3.66662 8.9643V7.33317Z"
				fill="currentColor"
			/>
		</svg>
	);
};
